import { render, staticRenderFns } from "./goodsCorporate.vue?vue&type=template&id=5a919592&scoped=true"
import script from "./goodsCorporate.vue?vue&type=script&lang=js"
export * from "./goodsCorporate.vue?vue&type=script&lang=js"
import style0 from "./goodsCorporate.vue?vue&type=style&index=0&id=5a919592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a919592",
  null
  
)

export default component.exports